// src/js/components/product-description.js
var ProductDescription = class extends HTMLElement {
  constructor() {
    super();
    this.descriptionElement = this.querySelector(".product__description");
    this.buttonElement = this.querySelector(".des-readmore");
    this.collapsedHeight = this.descriptionElement.style.maxHeight;
    this.buttonElement.addEventListener("click", () => this.toggleDescription());
  }
  toggleDescription() {
    if (this.descriptionElement.style.maxHeight === this.collapsedHeight) {
      const expandedHeight = this.descriptionElement.scrollHeight + "px";
      this.descriptionElement.style.maxHeight = expandedHeight;
      this.buttonElement.textContent = "\u2014read less";
    } else {
      this.descriptionElement.style.maxHeight = this.collapsedHeight;
      this.buttonElement.textContent = "\u2014more";
    }
  }
};
customElements.define("product-description", ProductDescription);
